// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/work-shifts",
  ListShort: "/pyr/work-shifts/short",
  ListShortPA: "/pyr/productivity-ot-data/work-shifts/short",
  Detail: "/pyr/work-shifts",
  Create: "/pyr/work-shifts",
  Update: "/pyr/work-shifts",
};
